// extracted by mini-css-extract-plugin
module.exports = {"mobileInput":"input_mobileInput__1S3c3"};